import { render, staticRenderFns } from "./PageTRAMS.vue?vue&type=template&id=310507f8"
import script from "./PageTRAMS.vue?vue&type=script&lang=js"
export * from "./PageTRAMS.vue?vue&type=script&lang=js"
import style0 from "./PageTRAMS.vue?vue&type=style&index=0&id=310507f8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports